import { Grid } from "@mui/material";
import RecursiveGroupSelector from "components/Classifiers/Common/RecursiveGroupSelector";
import { observer } from "mobx-react";
import type ChartCardStore from "../ChartCardStore";

type ClassifierGroupControlProps = {
    store: ChartCardStore;
};

const toPath = (value?: string | string[]): string[] => {
    if (Array.isArray(value)) return value;
    return value ? [value] : [];
};

/**
 * Chart control for the "Classifier Group" selection type. Wraps the reusable
 * cascading {@link RecursiveGroupSelector}; the selected path is persisted on
 * the store as `selectedIds.classifierGroup` (ordered root -> leaf) and its
 * deepest entry scopes the chart query.
 */
const ClassifierGroupControl = observer(
    ({ store }: ClassifierGroupControlProps) => {
        const path = toPath(store.selectedIds.classifierGroup);

        return (
            <Grid item>
                <RecursiveGroupSelector
                    value={path}
                    onChange={(nextPath) => {
                        store.setSelectedId("classifierGroup", nextPath);
                        store.handleSelectionChange();
                    }}
                    disabled={store.isReadOnly}
                    disabledAppearance="readOnly"
                />
            </Grid>
        );
    },
);

export default ClassifierGroupControl;
